import { useEffect, useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { Spinner } from 'components/UI';

const Loader = ({ messages }: { messages: { step?: string; step_a?: string } }) => {
  const [mainLoadingMessage, setMainLoadingMessage] = useState<string | undefined>('Request has been queued...');
  const [subLoadingMessage, setSubLoadingMessage] = useState<string | undefined>('');

  useEffect(() => {
    setMainLoadingMessage(messages?.step);
    setSubLoadingMessage(messages?.step_a);
  }, [messages.step]);

  return (
    <Box
      sx={{
        h: 180,
        w: 200,
        position: 'absolute',
        right: 10,
        bottom: 10,
        z: '2',
        bg: 'white',
      }}
      alignItems="center"
      borderRadius={5}
      justifyContent="center"
      data-testid="popup-loader"
    >
      <Flex justifyContent="center" pt={6}>
        <Spinner size="lg" thickness="5px" />
      </Flex>
      <Flex alignItems="center" flexDir="column">
        <Flex justifyContent="center" p={3} flexDirection="column" mt={1}>
          <Box textAlign="center" pt={2}>
            {mainLoadingMessage}
          </Box>
          <Box pt={2} textAlign="center" fontWeight="bold">
            {subLoadingMessage}
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Loader;
